import React, { useState } from 'react';
import {
  GeckoModal,
  GeckoModalService,
  GECKO_CONSTS,
  GeckoToastService,
} from '../../../ui';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import { GeckoAlert } from '../../../ui';
import { GeckoFields } from '../../../ui';
import AgentTeamSelect from 'components/AgentTeamSelect';

const MassAssignConversationModal = ({ setActionTimestamp, massAction }) => {
  const [newAssignedAgentsTeams, setNewAssignedAgentsTeams] = useState([]);

  const [actionTriggered, setActionTriggered] = useState(false);

  const field = () => {
    return [
      {
        key: 'value',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: <AgentTeamSelect value={values} multi={true} />,
        placeholder: 'Select Agents & Teams',
        width: '100',
      },
    ];
  };

  const values = { value: newAssignedAgentsTeams };

  const handleChange = (_key, value) => {
    setNewAssignedAgentsTeams(value);
  };

  const splitIds = (data) => {
    return data.reduce(
      (acc, item) => {
        const [type, id] = item.split('_');
        if (type === 'agent') {
          acc.agentIds.push(Number(id));
        } else if (type === 'team') {
          acc.teamIds.push(Number(id));
        }
        return acc;
      },
      { agentIds: [], teamIds: [] }
    );
  };

  const pluralize = (word, count) => {
    return count === 1 ? word : word + 's';
  };

  return (
    <GeckoModal
      name="Assign agents / teams"
      children={
        <>
          {!actionTriggered ? (
            <GeckoFields
              fields={field()}
              values={values}
              handler={handleChange}
            />
          ) : null}
          <div>
            <GeckoAlert type={'warning'}>
              {actionTriggered ? (
                `Updating assignments for ${
                  massAction.selected.length
                } ${pluralize('conversation', massAction.selected.length)}.`
              ) : (
                <>
                  This action will <strong>replace</strong> the exisiting
                  assigments for {massAction.selected.length}{' '}
                  {pluralize('conversation', massAction.selected.length)}.
                </>
              )}
            </GeckoAlert>
          </div>
        </>
      }
      btns={[
        {
          name: 'Cancel',
          secondary: true,
          icon: 'fa fa-times',
          handler: () => {
            return new GeckoModalService().close();
          },
          hideWhen: () => {
            return actionTriggered;
          },
        },
        {
          type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
          name: actionTriggered ? 'Assigning' : 'Done',
          icon: actionTriggered ? 'far fa-spinner spin' : 'fa fa-check-double',
          disabledWhen: () => {
            return (
              !newAssignedAgentsTeams.length ||
              !massAction.selected.length ||
              actionTriggered
            );
          },
          handler: () => {
            setActionTriggered(true);
            const { agentIds, teamIds } = splitIds(newAssignedAgentsTeams);
            GeckoRequest.post(`/conversation/mass-overwrite-assignments`, {
              conversationIds: massAction.selected,
              agentIds,
              teamIds,
            })
              .then(() => {
                new GeckoModalService().close();
                new GeckoToastService().success(
                  'Mass tags assignment complete'
                );
                setActionTriggered(false);
                setActionTimestamp(Date.now());
              })
              .catch((err) => {
                new GeckoModalService().close();
                setActionTriggered(false);
                new GeckoToastService().error(
                  'Mass agent / team assignment failed. Please try again. If the problem persists please contact support.'
                );
              });
          },
        },
      ]}
    />
  );
};

export default MassAssignConversationModal;
